import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { PlaylistService, SongsService, MessagesServices } from '../../../api/';
import { CreatePlaylistForm } from '../../../../models';
import { ToastyService, ToastyConfig, ToastOptions } from 'ng2-toasty';
import * as _ from 'lodash';
import { MdDialogRef } from '@angular/material';
import { PlayerService } from '../../../player';
@Component({
  selector: 'app-add-to-playlist-dialog',
  templateUrl: './add-to-playlist-dialog.component.html',
  styleUrls: ['./add-to-playlist-dialog.component.css']
})
export class AddToPlaylistDialogComponent implements OnInit {
  private playlists: any = [];
  public song: any;
  public playlist1: any;
  // public songId: any;
  private isSongInPlaylist: Array<any> = new Array<any>();
  private model: CreatePlaylistForm;
  private loading = true;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  disable: boolean = false;
  public onlineOffline1: boolean = navigator.onLine;
  page: number = 0;
  loadMore: boolean = false;
  constructor(private playerService: PlayerService, public dialogRef: MdDialogRef<AddToPlaylistDialogComponent>, private sm: MessagesServices, private playlistService: PlaylistService,
    private cdRef: ChangeDetectorRef, private songsService: SongsService, private toastyService: ToastyService,
    private toastyConfig: ToastyConfig, private router: Router) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});

    this.model = new CreatePlaylistForm();
    this.disable = false;
    //getting messages from db
    this.messages = this.sm.messags;
    this.setMessages();
  }
  /**
  * setting system messages
  **/

  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_PLAYLIST_CREATED_SUCCESSFULLY') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
      }
    }
  }

  ngOnInit() {
    this.loading = true;
    if(this.onlineOffline1) {
      this.userPlaylists();
    } else {
      this.loading = false;
    }
  }

  userPlaylists() {
    this.page = this.page + 1;
    this.playlistService.getUserPlaylists(this.page).subscribe((res) => {
      if(res['playlists'].length > 0) {
        res['playlists'].forEach(element => {
          this.playlists.push(element);
        });
        this.loadMore = true;
      }
      if(res['playlists'].length == 0 || res['playlists'].length < 20) {
        this.loadMore = false;
      }
      this.isSongAlreadyInPlaylist();
      this.loading = false;
      this.cdRef.detectChanges();
    });
  }

  isSongAlreadyInPlaylist() {
    _.each(this.playlists, (playlist) => {
      _.find(playlist.songsId, (song) => {
        if (this.song) {
          if (song === this.song.id) {
            this.isSongInPlaylist.push(parseInt(playlist.id));
          }
        } else if (this.playlist1) {
          for (var i = 0; i < this.playlist1.songsId.length; i++) {
            if (song === this.playlist1.songsId[i]) {
              this.isSongInPlaylist.push(parseInt(playlist.id));
            }
          }
        }
      });
    });
  }

  addToPlaylist(event, playlist: any) {
    if (this.song) {
      this.changeSongCounter(playlist.id);
      event.stopPropagation();
      event.preventDefault();
      if(this.onlineOffline1){
      this.songsService.addSongToPlaylist(playlist.id, this.song.id).subscribe(res => {
        console.log(res);
        if(res) {
          this.playerService.addTrack(this.song);
          this.playerService.addToPlaylist(this.song);
        }
      });
      }
    } else if (this.playlist1) {
      if(this.onlineOffline1){
      var cs = this.playerService.getRadioCurrentSong1(this.playlist1.radioUrl);
      for (var i = 0; i < this.playlist1.songsId.length; i++) {
        if (this.playlist1.songsId[i] != null) {

          if (this.playlist1.type == "R") {
            // alert("return");
            if (cs.id == this.playlist1.songsId[i]) {
              // alert("this is current song");
              this.songsService.addSongToPlaylist(playlist.id, this.playlist1.songsId[i]).subscribe(res => {
              });

              return;
            }
          } else {
            this.songsService.addSongToPlaylist(playlist.id, this.playlist1.songsId[i]).subscribe(res => {
            });
          }
        }
      }
    }
    }
  }

  deleteFromPlaylist(event, playlist: any) {
    this.changeSongCounter(playlist.id, true);
    event.stopPropagation();
    event.preventDefault();
    if(this.onlineOffline1){
    this.songsService.deleteSongFromPlaylist(playlist.id, this.song.id).subscribe(res => {
    });
    }
  }

  createPlaylist() {
    this.disable = true;
    // this.setMessages();
    if(this.onlineOffline1){
    this.playlistService.createPlaylistWithSongs(this.model, this.song).subscribe((res) => {
      this.dialogRef.close(true);
      let toastOptions: ToastOptions = {
        title: this.title1,
        msg: this.msg1,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.toastyService.success(toastOptions);
      this.disable = false;
    }, (err) => {

    });
    }else {
      this.disable = false;
    }
  }

  private changeSongCounter(playlistId: string, decrement = false) {
    this.playlists.forEach((k, v) => {
      if (k.id === playlistId) {
        if (!decrement) {
          this.playlists[v].songsCount = parseInt(this.playlists[v].songsCount) + 1;
          this.playlists[v].songsId.push(this.song.id);
          this.isSongInPlaylist.push(playlistId);
        } else {
          this.playlists[v].songsCount = parseInt(this.playlists[v].songsCount) - 1;
          this.playlists[v].songsId.splice(this.isSongInPlaylist.indexOf(playlistId), 1);
          this.isSongInPlaylist.splice(this.isSongInPlaylist.indexOf(playlistId), 1);
        }
      }
    });
  }

  navigateToPlaylist(playlist) {
    this.dialogRef.close(false);
    this.router.navigate(['/playlist/' + playlist.id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/songs/add-to-playlist/add-to-playlist-dialog/add-to-playlist-dialog.component.ts